import * as React from "react";

import Money from "web_modules/Money";

interface Props {
  heading: string;
  monthly_total: Number;
  ytd_total?: Number;
  year_minus_one_total?: Number;
  year_minus_two_total?: Number;
  current_ytd_total?: Number;
  showCurrent?: boolean;
}

function displayTotal(total) {
  if (total === undefined) {
    return "";
  }
  return total ? <Money value={total} /> : "-";
}

const Row: React.SFC<Props> = props => {
  const {
    showCurrent,
    heading,
    monthly_total,
    year_minus_two_total,
    year_minus_one_total,
    ytd_total,
    current_ytd_total,
  } = props;
  return (
    <tr>
      <td>{heading}</td>
      {showCurrent && <td>{displayTotal(current_ytd_total)}</td>}
      <td>{displayTotal(ytd_total)}</td>
      <td>{displayTotal(year_minus_one_total)}</td>
      <td>{displayTotal(year_minus_two_total)}</td>
      <td>{displayTotal(monthly_total)}</td>
    </tr>
  );
};

export default Row;
